import { api, mobile } from '@bilibili-maoer/web-utils'

import { ReactNode } from 'react'
import { Route, RouterProvider, createBrowserRouter, createRoutesFromElements } from 'react-router-dom'

import { AppError } from '~/app/error'
import * as Index from '~/pages'
import { SiteAnnouncementDetail } from '~/pages/announcement/announcement-detail'
import { SiteAnnouncements } from '~/pages/announcement/announcements'
import { GuildIndex } from '~/pages/guild'
import { GuildAnnouncementDetail } from '~/pages/guild/announcement-detail'
import { GuildAnnouncements } from '~/pages/guild/announcements'
import { GuildIncome } from '~/pages/guild/income'
import { GuildIncomeDetail } from '~/pages/guild/income-detail'
import { GuildReport } from '~/pages/guild/report'
import { GuildReportDetail } from '~/pages/guild/report-detail'
import { NotFound } from '~/pages/not-found'
import { CenterIndex } from '~/pages/user/center'
import { CenterFmAnnouncementDetail } from '~/pages/user/center/fm/announcement-detail'
import { CenterFmAnnouncements } from '~/pages/user/center/fm/announcements'
import { FollowList } from '~/pages/user/center/fm/follow-list'
import { Ranking } from '~/pages/user/center/fm/ranking'
import { PersonProfit } from '~/pages/user/center/person'
import * as UserGuild from '~/pages/user/guild'
import { GuildInvite } from '~/pages/user/guild/invite'
import { GuildJoin } from '~/pages/user/guild/join'
import { GuildProfit } from '~/pages/user/guild/profit'
import { GuildRenew } from '~/pages/user/guild/renew'
import { UserApi } from '~/services/fm/user'

const LoginRequiredRoute = ({ children }: { children?: ReactNode }) => {
  const { data: userInfo } = UserApi.getUserInfo.useQuery()
  if (!userInfo?.user) {
    window.location.replace(
      `${api.MISSEVAN_SITE_MAIN}/member/login?backurl=${encodeURIComponent(window.location.href)}`
    )
    return <NotFound />
  }
  return <>{children}</>
}

const Router = () => (
  <RouterProvider
    router={createBrowserRouter(
      createRoutesFromElements(
        <Route path="/" element={<Index.Layout />} errorElement={<NotFound />}>
          <Route errorElement={<NotFound />}>
            <Route index loader={() => AppError.throw({ type: 'NOT_FOUND' })} />
            {/* 全站直播公告 */}
            <Route path="announcements" element={<SiteAnnouncements />} />
            <Route path="announcement/:id" element={<SiteAnnouncementDetail />} />
            {/* 主播工作台 */}
            <Route
              path="user/center"
              element={
                <LoginRequiredRoute>
                  <CenterIndex.Layout />
                </LoginRequiredRoute>
              }
            >
              <Route
                index
                loader={() => {
                  window.location.replace(`${api.MISSEVAN_FM_API_PREFIX_URL}/user/center/statistics`)
                  return null
                }}
              />
              <Route path="follow" element={<FollowList />} />
              <Route
                path="room"
                loader={() => {
                  window.location.replace(`${api.MISSEVAN_API_PREFIX_URL}/mperson/center/#/room`)
                  return null
                }}
              />
              <Route path="ranking" element={<Ranking />} />
              <Route
                path="withdraw-account"
                loader={() => {
                  window.location.replace(`${api.MISSEVAN_API_PREFIX_URL}/mperson/center/#/withdraw-account`)
                  return null
                }}
              />
              <Route path="announcements" element={<CenterFmAnnouncements />} />
              <Route path="announcement/:id" element={<CenterFmAnnouncementDetail />} />
              <Route path="profit" element={<PersonProfit />} />
              <Route
                path="withdraw"
                loader={() => {
                  window.location.replace(`${api.MISSEVAN_API_PREFIX_URL}/mperson/center/#/withdraw`)
                  return null
                }}
              />
              <Route
                path="mperson/guild" // TODO: 我的公会迁移完成后这里需改为 guild 或做其他兼容调整
                loader={() => {
                  window.location.replace(`${api.MISSEVAN_API_PREFIX_URL}/mperson/center/#/guild`)
                  return null
                }}
              />
              <Route
                path="guild-record"
                loader={() => {
                  window.location.replace(`${api.MISSEVAN_API_PREFIX_URL}/mperson/center/#/guild-record`)
                  return null
                }}
              />
              <Route path="guild-profit" element={<GuildProfit />} />
            </Route>
            {/* 公会管理中心，兼容至 610 发版之后可以移动至 user/guild */}
            <Route path="user/center?/guild">
              <Route index Component={UserGuild.Page} />

              <Route path="join" element={<GuildJoin />} />
              <Route path="renew" element={<GuildRenew />} />
              <Route
                path="invite"
                element={<GuildInvite />}
                loader={() => {
                  if (!mobile.isMobile()) {
                    window.location.replace(`${api.MISSEVAN_API_PREFIX_URL}/mperson/center/#/guild-record`)
                  }
                  return null
                }}
              />
            </Route>
            {/* 公会管理中心 */}
            <Route
              path="guild"
              element={
                <LoginRequiredRoute>
                  <GuildIndex.Layout />
                </LoginRequiredRoute>
              }
            >
              <Route
                path="manage"
                loader={() => {
                  window.location.replace(`${api.MISSEVAN_FM_API_PREFIX_URL}/guild/manage`)
                  return null
                }}
              />
              <Route path="report" element={<GuildReport />} />
              <Route path="report/:live_id" element={<GuildReportDetail />} />
              <Route path="announcements" element={<GuildAnnouncements />} />
              <Route path="announcement/:id" element={<GuildAnnouncementDetail />} />
              <Route path="income" element={<GuildIncome />} />
              <Route path="income/:live_id" element={<GuildIncomeDetail />} />
              <Route
                path="applyment"
                loader={() => {
                  window.location.replace(`${api.MISSEVAN_FM_API_PREFIX_URL}/guild/applyment`)
                  return null
                }}
              />
              <Route
                path="agents"
                loader={() => {
                  window.location.replace(`${api.MISSEVAN_FM_API_PREFIX_URL}/guild/agents`)
                  return null
                }}
              />
              <Route
                path="recommend"
                loader={() => {
                  window.location.replace(`${api.MISSEVAN_FM_API_PREFIX_URL}/guild/recommend`)
                  return null
                }}
              />
            </Route>
          </Route>
        </Route>
      )
    )}
  />
)

export default Router
